import React, { useState, Children } from 'react';
import { CheckIcon, HomeIcon, BarChartIcon, UsersIcon, PresentationIcon, LayoutIcon, ArrowRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const HandshakeIcon = props => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-662">
    <path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78-.77-.78a5.4 5.4 0 0 0-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z" data-id="element-663"></path>
  </svg>;
const DollarSignIcon = props => <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-664">
    <line x1="12" y1="1" x2="12" y2="23" data-id="element-665"></line>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" data-id="element-666"></path>
  </svg>;
export const SellersSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    postalCode: '',
    propertyType: '',
    bedrooms: '',
    bathrooms: '',
    size: '',
    features: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
    alert('Thank you for your submission! We will contact you soon.');
  };
  const sellingSteps = [{
    number: 1,
    title: 'Strategic Marketing Campaign',
    description: 'We implement a tailored marketing strategy to ensure your home reaches the widest and most relevant audience, using a mix of online platforms, social media, and traditional advertising methods.',
    icon: <PresentationIcon className="h-10 w-10 text-[#00A3E0]" data-id="element-667" />
  }, {
    number: 2,
    title: 'Exceptional Client Service',
    description: 'We provide dedicated and personalized support throughout the entire selling process, addressing your needs and concerns with professionalism and care.',
    icon: <UsersIcon className="h-10 w-10 text-[#00A3E0]" data-id="element-668" />
  }, {
    number: 3,
    title: 'Detailed Visit Feedback',
    description: "We offer comprehensive feedback after each showing, giving you insights into potential buyers' reactions and helping us adjust our strategy for better results.",
    icon: <CheckIcon className="h-10 w-10 text-[#00A3E0]" data-id="element-669" />
  }, {
    number: 4,
    title: 'In-Depth Market Analysis',
    description: 'We conduct a thorough analysis of current market trends and comparable properties to set a competitive and accurate price for your home.',
    icon: <BarChartIcon className="h-10 w-10 text-[#00A3E0]" data-id="element-670" />
  }, {
    number: 5,
    title: 'Expert Negotiation Skills',
    description: 'We utilize advanced negotiation techniques to secure the best possible deal for you, ensuring favorable terms and conditions in every transaction.',
    icon: <HandshakeIcon className="h-10 w-10 text-[#00A3E0]" data-id="element-671" />
  }, {
    number: 6,
    title: 'Enhanced Property Presentation',
    description: 'Enhance the visual appeal and overall presentation of your home to make it more attractive to potential buyers, including staging and minor improvements.',
    icon: <LayoutIcon className="h-10 w-10 text-[#00A3E0]" data-id="element-672" />
  }];
  // Animation variants
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  const staggerContainer = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const listItem = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0
    }
  };
  const cardHover = {
    rest: {
      scale: 1,
      y: 0
    },
    hover: {
      scale: 1.03,
      y: -10,
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
    }
  };
  return <section className="w-full bg-[#f2f2ed]" data-id="element-673">
      {/* Hero Section */}
      <div className="pt-32 pb-20" data-id="element-674">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-675">
          <motion.div className="mb-16" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} transition={{
          duration: 0.6
        }} data-id="element-676">
            <h1 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-677">
              SELLER SERVICES
            </h1>
          </motion.div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-32" data-id="element-678">
            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-679">
              <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-680">
                Maximize Your Property's Value with Our Expert Selling Services
              </h2>
            </motion.div>
            <motion.div className="text-[#3a4a56]" initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={staggerContainer} data-id="element-681">
              <motion.p className="text-lg mb-8" variants={listItem} data-id="element-682">
                Selling your home is a significant milestone, and we're here to
                make the process smooth and successful. Our personalized
                approach includes expert marketing, strategic pricing, and
                seamless transaction management to ensure your peace of mind.
              </motion.p>
              <motion.p className="text-lg mb-8" variants={listItem} data-id="element-683">
                At Immovendu, we understand that selling your home is not just a
                transaction; it's a significant milestone in your life. That's
                why we're dedicated to providing you with the personalized
                support, expertise, and care you deserve every step of the way.
              </motion.p>
              <motion.p className="text-lg" variants={listItem} data-id="element-684">
                Our team brings years of experience and a deep understanding of
                the local market to help you achieve the best possible outcome
                for your property sale.
              </motion.p>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Our Commitment Section */}
      <div className="py-20 border-t border-[#3a4a56]" data-id="element-685">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-686">
          <motion.div className="mb-16" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} transition={{
          duration: 0.6
        }} data-id="element-687">
            <h6 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-688">
              OUR COMMITMENT
            </h6>
            <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-689">
              Your Trusted Real Estate Partner
            </h2>
          </motion.div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-690">
            <motion.div initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} whileHover={{
            scale: 1.03
          }} data-id="element-691">
              <img src="https://images.unsplash.com/photo-1582407947304-fd86f028f716?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2596&q=80" alt="Real estate professionals" className="w-full h-auto" data-id="element-692" />
            </motion.div>
            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            duration: 0.6,
            delay: 0.3
          }} data-id="element-693">
              <p className="text-lg text-[#3a4a56] mb-8" data-id="element-694">
                Let's embark on this exciting journey together and ensure a
                successful sale that's tailored to your unique needs and
                aspirations. Our team brings years of experience and a deep
                understanding of the local market to help you achieve the best
                possible outcome.
              </p>
              <motion.ul className="space-y-4" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} data-id="element-695">
                <motion.li className="flex items-start" variants={listItem} data-id="element-696">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-697" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-698">
                    Personalized selling strategy tailored to your property
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-699">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-700" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-701">
                    Professional photography and staging advice
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-702">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-703" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-704">
                    Strategic pricing based on comprehensive market analysis
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-705">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-706" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-707">
                    Expert negotiation to maximize your property's value
                  </span>
                </motion.li>
              </motion.ul>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Our Process Section */}
      <div className="py-20 border-t border-[#3a4a56]" data-id="element-708">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-709">
          <motion.div className="mb-16" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} transition={{
          duration: 0.6
        }} data-id="element-710">
            <h6 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-711">
              OUR PROCESS
            </h6>
            <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-712">
              Our Comprehensive Selling Approach
            </h2>
            <p className="text-lg text-[#3a4a56] max-w-3xl" data-id="element-713">
              Our proven process ensures your property sells quickly and at the
              best possible price. We handle every detail so you can focus on
              your next chapter.
            </p>
          </motion.div>
          <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} data-id="element-714">
            {sellingSteps.map((step, index) => <motion.div key={step.number} className="border-b border-[#3a4a56] pb-8" variants={listItem} transition={{
            type: 'spring',
            stiffness: 300
          }} data-id="element-715">
                <motion.div className="mb-6" initial={{
              scale: 1
            }} data-id="element-716">
                  {step.icon}
                </motion.div>
                <h3 className="text-xl font-normal text-[#3a4a56] mb-4" data-id="element-717">
                  {step.number}. {step.title}
                </h3>
                <p className="text-[#3a4a56]" data-id="element-718">{step.description}</p>
              </motion.div>)}
          </motion.div>
          <motion.div className="mt-16 text-center" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} data-id="element-719">
            <p className="text-lg text-[#3a4a56] max-w-3xl mx-auto mb-8" data-id="element-720">
              Thank you for considering us as your partner in selling your
              property. With our personalized approach, unwavering dedication,
              and heartfelt care, we're confident that we can help you achieve
              your selling goals and make your real estate dreams a reality.
            </p>
            <motion.a href="#seller-form" className="bg-[#3a4a56] hover:bg-[#2a3a46] text-white font-medium py-3 px-8 transition duration-200" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} transition={{
            type: 'spring',
            stiffness: 400
          }} data-id="element-721">
              Get Started Today
            </motion.a>
          </motion.div>
        </div>
      </div>

      {/* Form Section */}
      <div id="seller-form" className="py-20 border-t border-[#3a4a56]" data-id="element-722">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-723">
          <motion.div className="mb-16" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} transition={{
          duration: 0.6
        }} data-id="element-724">
            <h6 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-725">
              TELL US ABOUT YOUR PROPERTY
            </h6>
            <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-726">
              Ready to Sell?
            </h2>
          </motion.div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-32" data-id="element-727">
            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-728">
              <p className="text-lg text-[#3a4a56] mb-8" data-id="element-729">
                Fill out this form to help us understand your property and
                needs. Our expert team will analyze your information and connect
                with you to discuss the best strategy for selling your home.
              </p>
              <motion.ul className="space-y-4 mb-8" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} data-id="element-730">
                <motion.li className="flex items-start" variants={listItem} data-id="element-731">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-732" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-733">
                    Personalized selling strategy
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-734">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-735" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-736">
                    Comprehensive market analysis
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-737">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-738" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-739">
                    Expert guidance throughout the process
                  </span>
                </motion.li>
              </motion.ul>
            </motion.div>
            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            duration: 0.6,
            delay: 0.3
          }} data-id="element-740">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-741">
                <h3 className="text-xl font-normal text-[#3a4a56] mb-6" data-id="element-742">
                  Contact Information
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-743">
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-744">
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Full Name" required data-id="element-745" />
                  </motion.div>
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-746">
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Email Address" required data-id="element-747" />
                  </motion.div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-748">
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-749">
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Phone Number" required data-id="element-750" />
                  </motion.div>
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-751">
                    <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Property Address" required data-id="element-752" />
                  </motion.div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-753">
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-754">
                    <input type="text" id="city" name="city" value={formData.city} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="City" required data-id="element-755" />
                  </motion.div>
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-756">
                    <input type="text" id="postalCode" name="postalCode" value={formData.postalCode} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Postal Code" required data-id="element-757" />
                  </motion.div>
                </div>
                <motion.h3 className="text-xl font-normal text-[#3a4a56] mb-6 mt-10" initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4
              }} data-id="element-758">
                  Property Details
                </motion.h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-759">
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-760">
                    <select id="propertyType" name="propertyType" value={formData.propertyType} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" required data-id="element-761">
                      <option value="" data-id="element-762">Select Property Type</option>
                      <option value="Apartment" data-id="element-763">Apartment</option>
                      <option value="Building and business sale" data-id="element-764">
                        Building and business sale
                      </option>
                      <option value="Bungalow" data-id="element-765">Bungalow</option>
                      <option value="Chalet" data-id="element-766">Chalet</option>
                      <option value="Commercial Building" data-id="element-767">
                        Commercial Building
                      </option>
                      <option value="Cottage" data-id="element-768">Cottage</option>
                      <option value="Duplex" data-id="element-769">Duplex</option>
                      <option value="Farm" data-id="element-770">Farm</option>
                      <option value="Industrial Building" data-id="element-771">
                        Industrial Building
                      </option>
                      <option value="Loft / Studio" data-id="element-772">Loft / Studio</option>
                    </select>
                  </motion.div>
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-773">
                    <input type="text" id="size" name="size" value={formData.size} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" placeholder="Approximate Size (ft²)" data-id="element-774" />
                  </motion.div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-775">
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-776">
                    <select id="bedrooms" name="bedrooms" value={formData.bedrooms} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" data-id="element-777">
                      <option value="" data-id="element-778">Select Number of Bedrooms</option>
                      <option value="1" data-id="element-779">1</option>
                      <option value="2" data-id="element-780">2</option>
                      <option value="3" data-id="element-781">3</option>
                      <option value="4" data-id="element-782">4</option>
                      <option value="5+" data-id="element-783">5+</option>
                    </select>
                  </motion.div>
                  <motion.div whileHover={{
                  y: -5
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-784">
                    <select id="bathrooms" name="bathrooms" value={formData.bathrooms} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" data-id="element-785">
                      <option value="" data-id="element-786">Select Number of Bathrooms</option>
                      <option value="1" data-id="element-787">1</option>
                      <option value="1.5" data-id="element-788">1.5</option>
                      <option value="2" data-id="element-789">2</option>
                      <option value="2.5" data-id="element-790">2.5</option>
                      <option value="3+" data-id="element-791">3+</option>
                    </select>
                  </motion.div>
                </div>
                <motion.div whileHover={{
                y: -5
              }} transition={{
                type: 'spring',
                stiffness: 300
              }} data-id="element-792">
                  <textarea id="features" name="features" value={formData.features} onChange={handleChange} className="w-full px-4 py-3 border-b border-[#3a4a56] bg-transparent focus:outline-none focus:border-[#00A3E0]" rows={4} placeholder="Tell us about any specific features of your property (renovations, special amenities, etc.) or any other information that might be helpful." data-id="element-793"></textarea>
                </motion.div>
                <div data-id="element-794">
                  <motion.button type="submit" className="bg-[#3a4a56] hover:bg-[#2a3a46] text-white font-medium py-3 px-8 transition duration-200" whileHover={{
                  scale: 1.05
                }} whileTap={{
                  scale: 0.95
                }} transition={{
                  type: 'spring',
                  stiffness: 400
                }} data-id="element-795">
                    Submit Request
                  </motion.button>
                  <p className="text-sm text-[#3a4a56] mt-4" data-id="element-796">
                    By submitting this form, you agree to our privacy policy and
                    terms of service.
                  </p>
                </div>
              </form>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Guide Section */}
      <div className="py-20 border-t border-[#3a4a56]" data-id="element-797">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-798">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-799">
            <motion.div initial="hidden" whileInView="visible" viewport={{
            once: true
          }} variants={fadeIn} transition={{
            duration: 0.6
          }} data-id="element-800">
              <h6 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-801">
                FREE RESOURCE
              </h6>
              <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-802">
                Complete Seller's Guide
              </h2>
              <p className="text-lg text-[#3a4a56] mb-8" data-id="element-803">
                In this comprehensive seller's guide, you will find a wealth of
                relevant information and valuable advice to help you make your
                transaction a success. Download it for free!
              </p>
              <motion.ul className="mb-8 space-y-4" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} data-id="element-804">
                <motion.li className="flex items-start" variants={listItem} data-id="element-805">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-806" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-807">
                    Step-by-step selling process
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-808">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-809" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-810">
                    Home preparation checklist
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-811">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-812" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-813">
                    Pricing strategy guide
                  </span>
                </motion.li>
                <motion.li className="flex items-start" variants={listItem} data-id="element-814">
                  <CheckIcon className="h-5 w-5 text-[#00A3E0] mr-3 mt-1 flex-shrink-0" data-id="element-815" />
                  <span className="text-[#3a4a56] text-lg" data-id="element-816">
                    Negotiation and closing tips
                  </span>
                </motion.li>
              </motion.ul>
              <motion.a href="#" className="bg-[#3a4a56] hover:bg-[#2a3a46] text-white font-medium py-3 px-8 transition duration-200 inline-flex items-center" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} transition={{
              type: 'spring',
              stiffness: 400
            }} data-id="element-817">
                Download Free Guide
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-818" />
              </motion.a>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} data-id="element-819">
              <motion.img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1973&q=80" alt="Selling guide" className="w-full h-auto" whileHover={{
              scale: 1.03
            }} transition={{
              type: 'spring',
              stiffness: 300
            }} data-id="element-820" />
              <motion.div className="mt-6 border-t border-[#3a4a56] pt-6" initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.5
            }} data-id="element-821">
                <p className="text-[#3a4a56] font-normal" data-id="element-822">
                  100+ Pages of expert advice
                </p>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
};